import { IAppContext } from 'contextStore';
import { CLIENT_SOURCE_TYPE, TRADING_ACCOUNT_FORM_TYPE } from 'global.enums';
import { IUser } from 'global.interfaces';

export interface IContext {
  props: {
    typeTrigger: (value: number) => void;
    makeDepositReqTrigger: (value: boolean) => void;
  };
}

export enum ACCOUNT_CREATE_STEP {
  PLATFORMS = 'platforms',
  CREATE = 'create',
}

export interface IBaseAccountCreateProps {
  accountType: TRADING_ACCOUNT_FORM_TYPE;
  isBackButtonDisplayed: boolean;
  closeHandler: () => void;
  changeStep: (step: ACCOUNT_CREATE_STEP) => void;

  canSetIb: boolean;
  ibCodePrefix: string;
  clientSourceType: CLIENT_SOURCE_TYPE;
  user: IUser;
}

export type IBaseAccountCreateWithContext = IBaseAccountCreateProps & IAppContext;
